/* istanbul ignore file */

import api from 'config/axios';
import multipart from 'config/axiosMultpart';

import { duckStatusLoading, duckStatusLoadingGrid } from 'store/ducks/app';
import { getEnvValue } from 'config/enviroment';
import { interceptor } from 'config/interceptors';

export const getPadrao = (url, funcSuccess, isLoadingGrid = false) => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  return dispatch => {
    dispatch(duckLoading(true));
    api({
      url: `${getEnvValue('URL_API')}${url}`,
      method: 'GET',
    })
      .then(res => {
        funcSuccess(res?.data);
      })
      .catch(erro => {
        interceptor(erro);
        dispatch(duckLoading(false));
      })
      .finally(() => {
        dispatch(duckLoading(false));
      });
  };
};

export const getPadraoComRetorno = (url, isLoadingGrid = false, finalizarLoading = true) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  return new Promise((resolve, reject) => {
    dispatch(duckLoading(true));
    api({
      url: `${getEnvValue('URL_API')}${url}`,
      method: 'GET',
    })
      .then(res => {
        resolve(res?.data);
      })
      .catch(erro => {
        interceptor(erro);
        reject(erro);
        dispatch(duckLoading(false));
      })
      .finally(() => {
        finalizarLoading && dispatch(duckLoading(false));
      });
  });
};

export const postPadraoComRetorno = (url, dadosRequest, isLoadingGrid = false) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  return new Promise((resolve, reject) => {
    dispatch(duckLoading(true));
    api({
      url: `${getEnvValue('URL_API')}${url}`,
      method: 'POST',
      data: dadosRequest,
    })
      .then(res => {
        resolve(res?.data);
      })
      .catch(erro => {
        interceptor(erro);
        reject(erro);
        dispatch(duckLoading(false));
      })
      .finally(() => {
        dispatch(duckLoading(false));
      });
  });
};

export const postPadrao = (url, dadosRequest, funcSuccess, isLoadingGrid = false) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  dispatch(duckLoading(true));
  api({
    url: `${getEnvValue('URL_API')}${url}`,
    method: 'POST',
    data: dadosRequest,
  })
    .then(res => {
      funcSuccess(res?.data);
    })
    .catch(erro => {
      interceptor(erro);
      dispatch(duckLoading(false));
    })
    .finally(() => {
      dispatch(duckLoading(false));
    });
};

export const putPadrao = (url, dadosRequest, funcSuccess, isLoadingGrid = false) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  dispatch(duckLoading(true));
  api({
    url: `${getEnvValue('URL_API')}${url}`,
    method: 'PUT',
    data: dadosRequest,
  })
    .then(res => {
      funcSuccess(res?.data);
    })
    .catch(erro => {
      interceptor(erro);
      dispatch(duckLoading(false));
    })
    .finally(() => {
      dispatch(duckLoading(false));
    });
};

export const putPadraoComRetorno = (url, dadosRequest, isLoadingGrid = false) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  return new Promise((resolve, reject) => {
    dispatch(duckLoading(true));
    api({
      url: `${getEnvValue('URL_API')}${url}`,
      method: 'PUT',
      data: dadosRequest,
    })
      .then(res => {
        resolve(res?.data);
      })
      .catch(erro => {
        interceptor(erro);
        reject(erro);
        dispatch(duckLoading(false));
      })
      .finally(() => {
        dispatch(duckLoading(false));
      });
  });
};

export const deletePadrao = (url, funcSuccess, isLoadingGrid = false) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  return new Promise((resolve, reject) => {
    dispatch(duckLoading(true));
    api({
      url: `${getEnvValue('URL_API')}${url}`,
      method: 'DELETE',
    })
      .then(res => {
        funcSuccess(res?.data);
        resolve(res);
      })
      .catch(erro => {
        interceptor(erro);
        dispatch(duckLoading(false));
        reject(erro);
      })
      .finally(() => {
        dispatch(duckLoading(false));
      });
  });
};

export const getPadraoBlobComRetorno = (url, isLoadingGrid = false, finalizarLoading = true) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  return new Promise((resolve, reject) => {
    dispatch(duckLoading(true));
    api({
      url: `${getEnvValue('URL_API')}${url}`,
      method: 'GET',
      responseType: 'blob',
    })
      .then(res => {
        resolve(res?.data);
      })
      .catch(erro => {
        interceptor(erro);
        reject(erro);
        dispatch(duckLoading(false));
      })
      .finally(() => {
        finalizarLoading && dispatch(duckLoading(false));
      });
  });
};

export const postMultpartComRetorno = (url, dadosRequest, isLoadingGrid = false) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  return new Promise((resolve, reject) => {
    dispatch(duckLoading(true));
    api({
      url: `${getEnvValue('URL_API')}${url}`,
      method: 'POST',
      data: dadosRequest,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(res => {
        resolve(res?.data);
      })
      .catch(erro => {
        interceptor(erro);
        reject(erro);
        dispatch(duckLoading(false));
      })
      .finally(() => {
        dispatch(duckLoading(false));
      });
  });
};

export const getMultpartPadraoBlobComRetorno = (url, isLoadingGrid = false, finalizarLoading = true) => dispatch => {
  const duckLoading = isLoadingGrid ? duckStatusLoadingGrid : duckStatusLoading;
  return new Promise((resolve, reject) => {
    dispatch(duckLoading(true));
    multipart({
      url: `${getEnvValue('URL_API')}${url}`,
      method: 'GET',
      responseType: 'blob',
    })
      .then(res => {
        resolve(res?.data);
      })
      .catch(erro => {
        interceptor(erro);
        reject(erro);
        dispatch(duckLoading(false));
      })
      .finally(() => {
        finalizarLoading && dispatch(duckLoading(false));
      });
  });
};
